import { useEffect } from "react";

export default function PageMeta({ title, description, url }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      // meta description
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.setAttribute("name", "description");
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute("content", description);

      // Open Graph tags
      const setOG = (prop, value) => {
        let tag = document.querySelector(`meta[property="${prop}"]`);
        if (!tag) {
          tag = document.createElement("meta");
          tag.setAttribute("property", prop);
          document.head.appendChild(tag);
        }
        tag.setAttribute("content", value || "");
      };

      setOG("og:title", title || document.title);
      setOG("og:description", description);
      setOG("og:type", "website");
      if (url) setOG("og:url", url);
    }
  }, [title, description, url]);

  return null;
}
